import { isMobile } from '@manychat/manyui'

import { CheckoutTypes } from 'common/billing/constants/checkoutTypes'
import { StripeMetricsContext } from 'common/billing/entities/stripe/constants'
import { SendStripeCheckoutAnalytics } from 'common/billing/entities/stripe/interfaces'
import { ExtendedNetworkInformation } from 'utils/logWebVitals/logWebVitals'
import {
  analyticsService,
  dataLayer,
  gtmAnalytics,
  GTMAnalyticsEvents,
} from 'utils/services/analytics'

export const getStripeCheckoutType = (isTrialAvailable: boolean, isCouponApplied: boolean) => {
  return isTrialAvailable && !isCouponApplied ? CheckoutTypes.TRIAL : CheckoutTypes.UPGRADE_TO_PRO
}

export const sendStripeCheckoutAnalytics = ({
  checkoutType,
  currentPageId,
  userId,
  amount,
}: SendStripeCheckoutAnalytics) => {
  dataLayer.push({
    event: 'UPGRADED_TO_PRO',
    PAGE_ID: currentPageId || null,
    USER_ID: userId || null,
    SOURCE: checkoutType,
    AMOUNT: amount,
  })

  if (checkoutType === CheckoutTypes.TRIAL) {
    gtmAnalytics.sendConversationEvent(GTMAnalyticsEvents.TRIAL_CONNECTION)
  }
}

export const sendStripeMetric = (context: StripeMetricsContext) => {
  const connection: ExtendedNetworkInformation =
    // eslint-disable-next-line
    // @ts-expect-error
    navigator.connection || navigator?.mozConnection || navigator?.webkitConnection

  analyticsService.sendEvent('METRICS.CUSTOM.COUNT', {
    context,
    scope: isMobile ? 'mobile' : 'desktop',
    internet_speed: connection?.effectiveType ?? 'unknown',
    value: 1,
  })
}
